
var headers = {
    'Authorization': 'Bearer ' + sessionStorage.getItem('jwt_token')
}

var constants = {
    baseApiUrl: sessionStorage.getItem('customApiPath'),
    ctsApiUrl: sessionStorage.getItem('ctsApiUrl'),
    identityApiUrl: sessionStorage.getItem('authority'),
    viewerUrl: sessionStorage.getItem('viewerUrl'),
    client_version_Id: sessionStorage.getItem('client_version_Id'),
    signUsingUAEPassEnabled :JSON.parse(sessionStorage.getItem('sign_using_UAEPass')),
    signUsingDocusignEnabled :JSON.parse(sessionStorage.getItem('sign_using_Docusign')),
    esealEnabled :JSON.parse(sessionStorage.getItem('eseal')),
    ltvEnabled :JSON.parse(sessionStorage.getItem('ltv')),
    expandSentInboxRowFeature: sessionStorage.getItem('expandSentInboxRowFeature'),
    enableSpecialTemplate :JSON.parse(sessionStorage.getItem('enableSpecialTemplate')),
    isDesignPrimary: JSON.parse(sessionStorage.getItem('isDesignPrimary')),
    enableImpersonateSignatureInDelegation: sessionStorage.getItem('enableImpersonateSignatureInDelegation'),
    enableRecipientsMultiDocuments: sessionStorage.getItem('enableRecipientsMultiDocuments'),
    enableRecipientsMultiPages: sessionStorage.getItem('enableRecipientsMultiPages'),
    showIconsInsteadOfButtonsInCreateDocumentView: sessionStorage.getItem('showIconsInsteadOfButtonsInCreateDocumentView') === 'true',
    showReplyNeedReply: sessionStorage.getItem('showReplyNeedReply') === 'true',
    showFilingClassificationPlanSections: sessionStorage.getItem('showFilingClassificationPlanSections') === 'true',
    applicationTitle:sessionStorage.getItem("applicationTitle"),
    categories_has_configure_signature:sessionStorage.getItem("categories_has_configure_signature"),
    defaultApplicationId:sessionStorage.getItem("defaultApplicationId"),
    headers: headers,
    availableModules: sessionStorage.getItem("availableModules"),
    disclaimerMessage: sessionStorage.getItem("disclaimerMessage"),
    maxAttachmentSizeInByte:Window.maxAttachmentSizeInByte,
    maxAttachmentSizeInMb:Window.maxAttachmentSizeInMb,
    priorities: window.priorities,
    privacies: window.privacies,
    importancies: window.importancies,
    categories: window.categories,
    contactRoles: window.contactRoles,
    documentTypes: window.documentTypes,
    allowMultiStamp :JSON.parse(sessionStorage.getItem('allowMultiStamp')), 
    ViewerActionUrl :sessionStorage.getItem('customApiPath') + 'ViewerActions/',
    mandatoryDeliveryType:sessionStorage.getItem("mandatoryDeliveryType"),
    viewMultiDocumentOption: sessionStorage.getItem('viewMultiDocumentOption') === 'true',
    viewer_enableShowStamps : true,
    enableConfigrationSignature: false,
    isEsealEnabledTemplate: false,
    isUAEPassEnabledTemplate: false,
    contactRolesEnum: {
        Secretary: 1,
        Managers: 5,
    },
    fileExtensions: [
        { id: 1, name: "bmp" },
        { id: 2, name: "doc" },
        { id: 3, name: "docx" },
        { id: 4, name: "gif" },
        { id: 5, name: "jpg" },
        { id: 6, name: "pdf" },
        { id: 7, name: "png" },
        { id: 8, name: "ppt" },
        { id: 9, name: "pptx" },
        { id: 10, name: "svg" },
        { id: 11, name: "txt" },
        { id: 12, name: "xls" },
        { id: 13, name: "xlsx" },
        { id: 14, name: "bmp" },
        { id: 15, name: "tif" },
        { id: 16, name: "tiff" },
    ],
    languages: [
        { id: 'EN', name: "English" },
        { id: 'AR', name: "العربية" },
    ],
    applicationRoles: [],
    purposes: [],
    isApplicaitonRolesLoaded: false,

    delegations: [],
    isDelegationsLoaded: false,
    enableManageGridHeaders : true,
    canSignAndSend: false,
    canSign: false,
    canSendSecretTransfer: false,
    canOpenReports: false,
    isCompanyAdmin: false,
    isFullAdmin: false,
    roleName: '',
    isPermissionsLoaded: false,
    isDecreeEnabled: isDecreeEnabled,
    isCircularEnabled: isCircularEnabled,
    isMOMEnabled: isMOMEnabled,
    refreshSystemNotificationTimer: refreshSystemNotificationTimer,
    defaultDateValue: 'dd/mm/yyyy',
    showDateWithTime : true,
    showMoreFiltersInAdvancedSearch: false,
    multiSelectDocument: window.selectMultiDocument,
    showContentSearchInAdvancedSearch : window.showContentSearchInAdvancedSearch,

    statuses: [
        { id: 1, name: 'Draft', nameAr: 'مسودة', key: 'Draft', classColor: '' },
        { id: 2, name: 'In progress', nameAr: 'قيد التنفيذ', key: 'InProgress', classColor: 'info' },
        { id: 3, name: 'Completed', nameAr: 'منجز', key: 'Completed', classColor: 'success' },
        { id: 4, name: 'Canceled', nameAr: 'ملغاة', key: 'Canceled', classColor: 'danger' },
        { id: 5, name: 'Signed', nameAr: 'موقعة', key: 'Signed', classColor: 'info' }
    ],

    statusesEnum: {
        getById: function (id) {
            for (var i = 0; i < constants.statuses.length; i++) 
            {
                if (constants.statuses[i].id == id)
                    return constants.statusesEnum[constants.statuses[i].key]
            }

            return {};
        },
        Draft: {
            key: 'Draft',
            value: 1,
            data: function () {
                return constants.statuses.filter(x => x.id == this.value)[0];
            }
        },
        InProgress: {
            key: 'InProgress',
            value: 2,
            data: function () {
                return constants.statuses.filter(x => x.id == this.value)[0];
            }
        },
        Completed: {
            key: 'Completed',
            value: 3,
            data: function () {
                return constants.statuses.filter(x => x.id == this.value)[0];
            }
        },
        Canceled: {
            key: 'Canceled',
            value: 4,
            data: function () {
                return constants.statuses.filter(x => x.id == this.value)[0];
            }
        },
        Signed: {
            key: 'Signed',
            value: 5,
            data: function () {
                return constants.statuses.filter(x => x.id == this.value)[0];
            }
        }
    },
    categoriesEnum: {
        Incoming: 1,
        Outgoing: 2,
        Internal: 3,
        Decree: 4,
        Circular: 5,
    },
    categories_Helper_Enum: {
        getByKey:function (key)
        {
            for (var tmpKey in this) 
            {
                if (this.hasOwnProperty(tmpKey)) 
                {
                    var item = this[tmpKey];
                    if (item.key === key)
                        return item;
                }
            }

            return {};
        },
        Incoming: { key: 'Incoming', value: 1, text: 'res_incoming' }, 
        Outgoing: { key: 'Outgoing', value: 2, text: 'res_outgoing' }, 
        Internal: { key: 'Internal', value: 3, text: 'res_internal' }, 
        Decree: { key: 'Decree', value: 4, text: 'res_MenuItems_Decree' }, 
        Circular: { key: 'Circular', value: 5, text: 'res_MenuItems_Circular' }, 
    },
    deliveryType_Enum: {
        email: 1,
        fax: 2,
        relatedStructure: 3,
        logisticsServices: 4
    },
    signStatusEnum: {
        getByKey:function (key)
        {
            for (var tmpKey in this) 
            {
                if (this.hasOwnProperty(tmpKey)) 
                {
                    var item = this[tmpKey];
                    if (item.key === key)
                        return item;
                }
            }

            return {};
        },
        Pending: { key: 'Pending', value: 1, text: 'res_Label_Pending' },
        InProgress: { key:'In Progress', value: 2, text: 'res_Label_InProgress' },
        Signed: { key: 'Signed', value: 3, text: 'res_Label_Signed' },
    },
    templateSignatureCountLimit: 20,

    actionsEnum: {
        features:{
            Sign: {
                key: 'sign',
                value: 1,
            },
            SignAndSend: {
                key: 'signandsend',
                value: 2,
            },
            VisualTracking: {
                key: 'visualtracking',
                value: 3,
            },
            SecretTransfer: {
                key: 'secrettransfer',
                value: 4,
            },
            Reports: {
                key: 'reports',
                value: 5,
            },
            CreateDesignatedPerson: {
                key: 'createdesignatedperson',
                value: 6,
            },
            DocumentTags: {
                key: 'documenttags',
                value: 6,
            },
            DocumentTagsAdd: {
                key: 'documenttags-add',
                value: 6,
            },
        },
        toolbarMenu: {
            PublishToMultiDocument: {
                key: 'publishtomultidocument',
                value: 1
            },
            DispatchCorrespondence: {
                key: 'dispatchcorrespondence',
                value: 1
            },
            VisualTracking: {
                key: 'visualtracking',
                value: 1
            },
            Preview: {
                key: 'preview',
                value: 1
            },
            SigningHistory: {
                key: 'signinghistory',
                value: 1
            },
            Forward: {
                key: 'forward',
                value: 1
            },
            Endorse: {
                key: 'endorse',
                value: 1
            },
            Archive: {
                key: 'archive',
                value: 1
            },
            SendBack: {
                key: 'sendback',
                value: 1
            },
            Reject: {
                key: 'reject',
                value: 1
            },
            Recall: {
                key: 'recall',
                value: 1
            },
            DeleteDraft: {
                key: 'deletedraft',
                value: 1
            },
            NotifyEmail: {
                key: 'notifyemail',
                value: 1
            },
            CancelFollowup: {
                key: 'cancelfollowup',
                value: 1
            },
            Sign: {
                key: 'sign',
                value: 1
            },
            SignAndSend: {
                key: 'signandsend',
                value: 1
            },
            Dismiss: {
                key: 'dismiss',
                value: 1
            },
            CreateOutgoing: {
                key: 'createoutgoing',
                value: 1
            },
            ForceGenerateReferenceNumber: {
                key: 'forcegeneratereferencenumber',
                value: 1
            },
            GenerateDeliveryNote:{
                key: "generatedeliverynote",
                value: 1
            },
            HideCorrespondence:{
                key: "hidecorrespondence",
                value: 1
            },
            EmailReminder:{
                key: "emailreminder",
                value: 1
            },
            TaskReminder:{
                key: "taskreminder",
                value: 1
            },
             ResetDocument:{
                key: "resetdocument",
                value: 1
            },
            Approve:{
                key:"approve",
                value: 1
            },
            Replace:{
                key:"replace",
                value: 1
            },
            ReplaceOriginalMail:{
                key:"replaceoriginalmail",
                value: 1
            },
            SendCC: {
                key: 'sendcc',
                value: 1
            },


        }
    },

    // for adfd
    countriesList: [],
    projectsList: [],
    projectsNumbersList: [],

    userActions: {},

    showDocumentType: sessionStorage.getItem('showDocumentType') === 'true',
};

if (constants.client_version_Id == 'ADFD') 
{
    constants.privacies = [ { id: 1, name: 'Public', nameAr: 'عام' },
                            { id: 2, name: 'Restricted', nameAr: 'محدود' },
                            { id: 3, name: 'Confidential', nameAr: 'سري' },
                            { id: 4, name: 'Secret', nameAr: 'سري للغاية' }]
}

if (localStorage.getItem('lang') == 'ar') 
{
    let toBeTranslatedProperties = ['priorities', 'privacies', 'importancies', 'statuses', 'categories', 'contactRoles', 'documentTypes']
    for (var i = 0; i < toBeTranslatedProperties.length; i++) 
    {
        if (constants[toBeTranslatedProperties[i]] == null || constants[toBeTranslatedProperties[i]] == undefined)
            continue;
        
        for (var j = 0; j < constants[toBeTranslatedProperties[i]].length; j++) 
        {
            constants[toBeTranslatedProperties[i]][j].name = constants[toBeTranslatedProperties[i]][j].nameAr;
        }
    }
}

export default constants;